/*
 * @Author: suxueqin
 * @Date: 2021-01-06
 * @Last Modified by: yanghuizi
 * @Last Modified time: 2021-06-11 15:47:40
 */
import { qstringify } from "./func";
import { IS_DEV } from "../consts";
class Site {
  constructor(host) {
    this.host = host;
  }

  url(path, queries) {
    if (!path) path = "";
    if (!path.startsWith("/")) {
      path = "/" + path;
    }
    let url = `https://${this.host}${path}`;
    let qs = qstringify(queries);
    return qs ? `${url}?${qs}` : url;
  }
}

// 业务域名
const domains = {
  soso: IS_DEV ? "demo-soso.tingsonglaw.com" : "soso.tingsonglaw.com",
  muc: IS_DEV ? "demo-muc.tingsonglaw.com" : "muc.tingsonglaw.com",
  api: IS_DEV ? "demo-api.tingsonglaw.com" : "api.tingsonglaw.com", 
  inlawyer: IS_DEV ? "demo-inlawyer.tingsonglaw.com" : "www.tingsonglaw.com",
  lawyer: IS_DEV ? "demo-inlawyer.tingsonglaw.com" : "inlawyer.tingsonglaw.com",
  ask: IS_DEV ? "demo-ask.tingsonglaw.com" : "ask.tingsonglaw.com",
  uc: IS_DEV ? "demo-uc.tingsonglaw.com" : "uc.tingsonglaw.com",
  www: IS_DEV ? "demo-www.tingsonglaw.com" : "www.tingsonglaw.com",
  pay: IS_DEV ? "demo-pay.tingsonglaw.com" : "pay.tingsonglaw.com",
  upload: IS_DEV ? "demo-upload.tingsonglaw.com" : "upload.tingsonglaw.com",
  m: IS_DEV ? "demo-m.tingsonglaw.com" : "m.tingsonglaw.com",
  h5site: IS_DEV ? "demo-h5site.tingsonglaw.com" : "h5site.tingsonglaw.com",
  pubapi: IS_DEV ? "demo-pubapi.tingsonglaw.com" : "pubapi.tingsonglaw.com"
};

let site = {};

for (let name in domains) {
  site[name] = new Site(domains[name]);
}

export { site };


// WEBPACK FOOTER //
// ./src/utils/site.js